enum PaymentStatusEnum {
	Paid = 'paid',
	Open = 'open',
	Pending = 'pending',
	Overdue = 'overdue',
	Canceled = 'canceled',
}

export default PaymentStatusEnum;
